/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { webhooksPing } from "../../funcs/webhooksPing.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.PingWebhookRequest$inboundSchema,
};

export const tool$webhooksPing: ToolDefinition<typeof args> = {
  name: "webhooks-ping",
  description:
    `Send a test ping to a webhook to verify it is configured correctly.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await webhooksPing(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
